import React from "react";
import PropTypes from "prop-types";

const CheckIcons = ({ number }) => {
    const icons = [];

    for (let i = 1; i <= 3; i++) {
        if (i <= number) {
            icons.push(<i key={i} className="fas fa-check-square" style={{ color: "green" }}></i>);
        } else {
            icons.push(<i key={i} className="fas fa-check-square"></i>);
        }
    }

    return <>{icons}</>;
};

CheckIcons.propTypes = {
    number: PropTypes.number.isRequired,
};

export default CheckIcons;